export default __webpack_public_path__ + "static/media/step-one-bee.b2fd1ec7.jpg";